import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import clsx from 'clsx';
import { getIsMd } from '../../../redux/selectors';
import { TextField } from '../..';
import Tooltip from '@mui/material/Tooltip';

const TextFieldRow = ({
	label,
	children,
	tooltip,
	required = false,
	...rest
}) => {
	const theme = useTheme();
	const useStyles = makeStyles(() => {
		return {
			textFieldRowRoot: {
				width: '100%',
				height: '68px',
				maxWidth: theme.width.contentMax,
				minWidth: theme.width.contentMin,
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				[theme.breakpoints.down('md')]: {
					minWidth: 'unset',
				},
			},
			textFieldRowLabel: {
				color: theme.palette.font.gray,
				fontSize: '16px',
				width: '150px',
				minWidth: '150px',
				[theme.breakpoints.down('md')]: {
					display: 'none',
				},
			},
			textFieldRowLabelRequired: {
				'&::after': {
					color: theme.palette.error.main,
					content: '"\u00A0*"',
				},
			},
			textFieldRowInput: {
				width: 'calc(100% - 140px)',
				[theme.breakpoints.down('md')]: {
					width: '100%',
				},
			},
		};
	});

	const classes = useStyles();
	const isMd = useSelector(getIsMd);

	const tooltipWrap = (
		children,
		{ placement = 'top-start', ...params } = {}
	) => {
		if (tooltip)
			return (
				<Tooltip placement={placement} {...params} title={tooltip}>
					<>{children}</>
				</Tooltip>
			);

		return children;
	};

	return (
		<div className={classes.textFieldRowRoot}>
			{tooltipWrap(
				<div
					className={clsx(
						classes.textFieldRowLabel,
						required && classes.textFieldRowLabelRequired
					)}>
					{label}
				</div>
			)}
			<div className={classes.textFieldRowInput}>
				{children && !rest.select
					? children
					: tooltipWrap(
							<TextField
								required={required}
								{...rest}
								label={isMd && label ? label : null}>
								{children}
							</TextField>,
							{
								disableHoverListener: true,
							}
					  )}
			</div>
		</div>
	);
};

export default TextFieldRow;
